"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDocumentStatus = exports.CompanyDocumentType = exports.CompanyDocumentEntityType = void 0;
// ---------------------------------------------------------------------------
// Enums
// ---------------------------------------------------------------------------
/** What entity the document belongs to — primary grouping axis for queries and the download centre */
var CompanyDocumentEntityType;
(function (CompanyDocumentEntityType) {
    CompanyDocumentEntityType["COMPANY"] = "company";
    CompanyDocumentEntityType["ORDER"] = "order";
    CompanyDocumentEntityType["PAYMENT"] = "payment";
    CompanyDocumentEntityType["SUBSCRIPTION"] = "subscription";
})(CompanyDocumentEntityType = exports.CompanyDocumentEntityType || (exports.CompanyDocumentEntityType = {}));
/** What kind of document it is — secondary axis within an entity type */
var CompanyDocumentType;
(function (CompanyDocumentType) {
    CompanyDocumentType["RYFT_FEE_INVOICE"] = "ryft_fee_invoice";
    CompanyDocumentType["ORDER_INVOICE"] = "order_invoice";
    CompanyDocumentType["ORDER_RECEIPT"] = "order_receipt";
    CompanyDocumentType["BILLING_INVOICE"] = "billing_invoice";
    CompanyDocumentType["COMPANY_STATEMENT"] = "company_statement";
    CompanyDocumentType["CSV_EXPORT"] = "csv_export";
})(CompanyDocumentType = exports.CompanyDocumentType || (exports.CompanyDocumentType = {}));
var CompanyDocumentStatus;
(function (CompanyDocumentStatus) {
    CompanyDocumentStatus["PROCESSING"] = "processing";
    CompanyDocumentStatus["DRAFT"] = "draft";
    CompanyDocumentStatus["FINALIZED"] = "finalized";
    CompanyDocumentStatus["FINALIZED_WITH_WARNINGS"] = "finalized_with_warnings";
    CompanyDocumentStatus["VOID"] = "void";
    CompanyDocumentStatus["FAILED"] = "failed";
})(CompanyDocumentStatus = exports.CompanyDocumentStatus || (exports.CompanyDocumentStatus = {}));
